module.exports = __webpack_public_path__ + "static/media/confirm.d2601fb2.png";